module.exports = __webpack_public_path__ + "0eee609a0ce348f1bde697bf385034f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/lyzak-6.jpg
// module id = 1188
// module chunks = 0